  
<div *ngIf="boxData" class="box-wrapper">
    <div class="box-wrapper-inner">
        <div *ngFor="let el of boxData">
            <h2 *ngIf="el[0] == 'h2'">{{ el[1] }}</h2>
            <div *ngIf="el[0] == 'img'" class="standardboximage">
                <img *ngIf="el[1].height" class="image-setSize" [height]="el[1].height" [width]="el[1].width" [src]="el[1].path" [alt]="el[1].alt">
                <img *ngIf="!el[1].height" class="image-standard" [src]="el[1].path" [alt]="el[1].alt">
                <div *ngIf="el[1].captionBold" class="captionBold">{{ el[1].captionBold }}</div>
            </div>
            <p *ngIf="el[0] == 'p'">{{ el[1] }}</p>
            <p *ngIf="el[0] == 'pi'"><i>{{ el[1] }}</i></p>
            <p *ngIf="el[0] == 'pb'"><strong>{{ el[1] }}</strong></p>
            <br *ngIf="el[0] == 'empty'">
            <div *ngIf="el[0] == 'footer-header'" class="footer-header">{{ el[1] }}</div>
            <div *ngIf="el[0] == 'footer-normal'" class="footer-normal">{{ el[1] }}</div>
            <div *ngIf="el[0] == 'footer-large'" class="footer-large">{{ el[1] }}</div>
            <div *ngIf="el[0] == 'footer-social'" class="footer-social">
                <div *ngFor="let social of el[1]" class="footer-social-item">
                    <a [href]="social.type"><img [src]="'assets/images/theme-images/social/' + social.type + '.png'" [height]="social.size" [width]="social.size"></a>
                </div>
            </div> 
            <div *ngIf="el[0] == 'footer-whatsapp'" class="footer-whatsapp">
                <img [src]="'assets/images/theme-images/social/whatsapp.png'" [height]="el[1].size" [width]="el[1].size">
                <div>{{ el[1].number }}</div>
            </div>
            <div *ngIf="el[0] == 'image-slider'">
                <ng-image-slider [images]="el[1]" [imageSize]="{width: 240, height: 160, space: 4}" #nav></ng-image-slider>
            </div>
        </div>
    </div>
</div>